import { register, getPrefix, attachScripts, applyAll } from '../../../Utils'
import * as constants from '../../../../../../designTokens.json'

/* Prüfen: mehrere Carousels auf einer Seite? */

const Carousel = el => {
  const prefix = getPrefix(el)
  const scripts = [
    'https://cdnjs.cloudflare.com/ajax/libs/tiny-slider/2.9.2/min/tiny-slider.js' // lokal hosten
  ]

  const initSlider = () => {
    let tns = window.tns

    const mainSlider = tns({
      container: el.querySelector(`.${prefix}carousel-inner`),
      gutter: 30,
      items: 1,
      slideBy: 'page',
      nav: false,
      responsive: {
        [constants.mediaBreakpoints.m.replace(/\D/g, '')]: { // kann man sauberer machen
          items: +el.dataset.slidestoshow || 1,
          slideBy: el.dataset.slidestoscroll || 'page'
        }
      },
      autoplay: el.dataset.autoplay || false,
      speed: 600,
      autoplayTimeout: 6000,
      loop: el.dataset.loop || true,
      prevButton: el.querySelector(`.${prefix}carousel-prev`),
      nextButton: el.querySelector(`.${prefix}carousel-next`)
    })

    if (el.dataset.thumbnav) {
      const naviBlockwise = true
      const thumbLinks = el.querySelectorAll('.' + prefix + 'thumbnav-inner > div') // literal string
      const showNavSlides = 3

      const navSlider = tns({
        container: el.querySelector(`.${prefix}thumbnav-inner`),
        gutter: 10,
        items: showNavSlides,
        slideBy: showNavSlides,
        nav: false,
        autoplay: false,
        speed: 600,
        loop: false,
        prevButton: el.querySelector(`.${prefix}thumbnav-prev`),
        nextButton: el.querySelector(`.${prefix}thumbnav-next`)
      })

      const slideSum = mainSlider.getInfo().slideCount
      let targetThumb

      mainSlider.events.on('indexChanged', e => {
        // applyAll(el)
        const index = e.index > slideSum ? 0 : e.index - 1
        const previous = e.indexCached - 1

        if (index >= 0 && index < thumbLinks.length) {
          if (thumbLinks[previous]) {
            thumbLinks[previous].classList.remove(el.dataset.prefix + 'is--current')
          }
          thumbLinks[index].classList.add(el.dataset.prefix + 'is--current')
        }

        if (naviBlockwise) {
          targetThumb = index - index % showNavSlides
        } else {
          targetThumb = index - Math.floor(showNavSlides / 2)
        }

        navSlider.goTo(targetThumb)
        // setInfoText(index + 1, slideSum)
      })

      thumbLinks.forEach((thumb, index) => {
        thumb.addEventListener('click', e => {
          mainSlider.goTo(index)
        })
      })

      // setInfoText(1, slideSum)
      thumbLinks[0].classList.add(el.dataset.prefix + 'is--current')
    }
  }

  if (typeof window.tns !== 'undefined') {
    initSlider()
  } else {
    attachScripts(scripts, el, initSlider)
  }
}

register('Carousel', Carousel)
